import React, { useEffect, useState } from "react";
import { IconButton, Container, Box, LinearProgress, TextField } from "@mui/material";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import apiClient from "../api/apiClient";
import { uD } from '../context/DC';
import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Autocomplete from '@mui/material/Autocomplete';
import DeleteIcon from "@mui/icons-material/Delete";

const DisplayBookbank = () => {  
  const token = localStorage.getItem("token");
  const { mG } = uD();
  const [pg, sP] = useState(0); 
  const [ld, sL] = useState(true); 
  const [ac, sAc] = useState([]);
  const [sac, sSAc] = useState([]);
  const [d, sD] = useState([]);
  const [d2, sD2] = useState(null);
  const [d3, sD3] = useState(null);
  const [s, sS] = useState([]);

  const fD = async () => {
    sL(true);   
    sP(0); 
    try {         
      const r = await apiClient.get("/api-data/master-accshortbookbank", {headers: { "Authorization": `Bearer ${token}` ,},});
      if (r.data.s=='0' && r.data.d.rowCount > 0) {
        sAc(r.data.d.rows);
      } else {
        await mG({t: "Failed",tc: "#e40000",m: r.data.m,bt: "Close",btc: "white",bc: "#ff1616",bch: "#d40000",}); 
      }      
    } catch (error) {
      let errMsg = "";
      if (error?.response?.data) {errMsg = error.response.data.error ||error.response.data.message ||JSON.stringify(error.response.data);
      } else if (error?.message) {errMsg = error.message;}
      await mG({t: "Failed",tc: "#e40000",m: errMsg || "Please contact aiscimer team.",bt: "Close",btc: "white",bc: "#ff1616",bch: "#d40000",}); 
    }
    sL(false);
    sP(100);
  };

  useEffect(() => {
    fD();
  }, []);

  const fR = async () => {
    sL(true);
    sP(0);
    sD([]); 
    try {  
      const d = {d2: dayjs(d2).format('YYYY-MM-DD'), d3: dayjs(d3).format('YYYY-MM-DD'), c2: sac?.length ? sac.map(item => item.c2) : null};
      const r = await apiClient.get("/api-data/banktransaction-getbookbank", {headers: { Authorization: `Bearer ${token}` },params: d });
      if (r.data.s=='0' && r.data.d.rowCount > 0) {
        sD(r.data.d.rows);
        sS([]);
      } else if (r.data.s=='0' && r.data.d.rowCount == 0) {
        await mG({t: "Warning",tc: "#ffa000",m: "ไม่พบข้อมูล กรุณาค้นหาข้อมูลใหม่อีกครั้ง",bt: "OK",btc: "white",bc: "#ffb300",bch: "#ff6f00",}); 
      } else {
        await mG({t: "Failed",tc: "#e40000",m: r.data.m,bt: "Close",btc: "white",bc: "#ff1616",bch: "#d40000",}); 
      }      
    } catch (error) {
      let errMsg = "";
      if (error?.response?.data) {errMsg = error.response.data.error ||error.response.data.message ||JSON.stringify(error.response.data);
      } else if (error?.message) {errMsg = error.message;}
      await mG({t: "Failed",tc: "#e40000",m: errMsg || "Please contact aiscimer team.",bt: "Close",btc: "white",bc: "#ff1616",bch: "#d40000",}); 
    }
    sL(false);
    sP(100);
  };

const hCbS = (d) => {
  sS((prevSelected) =>
      prevSelected.some((f) => f.i13 === d.i13)
          ? prevSelected.filter((f) => f.i13 !== d.i13)
          : [...prevSelected, d]
  );
};

const hCbA = () => {
  if (s.length === d.length) {
      sS([]); 
  } else {
      sS([...d]); 
  }
};

const hD = async (s) => {
  try {
    const i = await mG({t: "Delete",tc: "#e40000",m: "คุณแน่ใจหรือไม่ว่าต้องการลบข้อมูลนี้?",bt: "Cancel",btc: "white",bc: "#66bb49",bch: "#3f762c",cf: true,bcfc: "#ff1616",bcfh: "#d40000",bcft: "Confirm",}); 
    if (i) { 
      const r = await apiClient.post("/api-data/banktransaction-delbookbank", s, {
        headers: {'s': '0502',  "Authorization": `Bearer ${token}` ,},});
      if (r.data.s === "0") {
        await mG({t: "Completed",tc: "#519a39",m: r.data.m,bt: "OK",btc: "white",bc: "#66bb49",bch: "#3f762c",});         
        sD((prevFiles) => prevFiles.filter((f) => f.i13 !== s.i13));
        sS((prevSelected) => prevSelected.filter((f) => f.i13 !== s.i13));
      } else {
        await mG({t: "Failed",tc: "#e40000",m: r.data.m,bt: "Close",btc: "white",bc: "#ff1616",bch: "#d40000",}); 
      }  
    } 
  } catch (error) {
    let errMsg = "";
      if (error?.response?.data) {errMsg = error.response.data.error ||error.response.data.message ||JSON.stringify(error.response.data);
      } else if (error?.message) {errMsg = error.message;}
      await mG({t: "Failed",tc: "#e40000",m: errMsg || "Please contact aiscimer team.",bt: "Close",btc: "white",bc: "#ff1616",bch: "#d40000",}); 
  }
};

const hDS = async () => {
  try {
    if (s.length === 0) {
      await mG({t: "Failed",tc: "#e40000",m: "กรุณาเลือกอย่างน้อย 1 รายการ",bt: "Close",btc: "white",bc: "#ff1616",bch: "#d40000",}); 
      return;
    }
    const i = await mG({t: "Delete",tc: "#e40000",m: "คุณแน่ใจหรือไม่ว่าต้องการลบข้อมูลนี้?",bt: "Cancel",btc: "white",bc: "#66bb49",bch: "#3f762c",cf: true,bcfc: "#ff1616",bcfh: "#d40000",bcft: "Confirm",}); 
    if (i) { 
      const r = await apiClient.post("/api-data/banktransaction-delbookbank", s, {
        headers: {'s': '0502',  "Authorization": `Bearer ${token}` ,},});
      if (r.data.s == "0") {
        await mG({t: "Completed",tc: "#519a39",m: r.data.m,bt: "OK",btc: "white",bc: "#66bb49",bch: "#3f762c",});         
        sD((prevFiles) => prevFiles.filter((f) => !s.includes(f)));
        sS([]);
      } else {
        for (const row of r.data.d) {
          sD((prevFiles) => prevFiles.filter((f) => f.i13 !== row));
          sS((prevSelected) => prevSelected.filter((f) => f.i13 !== row));
        }
        await mG({t: "Failed",tc: "#e40000",m: r.data.m,bt: "Close",btc: "white",bc: "#ff1616",bch: "#d40000",}); 
      }  
    }       
  } catch (error) {
    let errMsg = "";
      if (error?.response?.data) {errMsg = error.response.data.error ||error.response.data.message ||JSON.stringify(error.response.data);
      } else if (error?.message) {errMsg = error.message;}
      await mG({t: "Failed",tc: "#e40000",m: errMsg || "Please contact aiscimer team.",bt: "Close",btc: "white",bc: "#ff1616",bch: "#d40000",}); 
  }
};

  return (
    <Container component="main" maxWidth="96%" sx={{marginTop: "40px",border: "0px solid #e0e0e0",boxSizing: "border-box",}}>
            {ld ? (
              <Box sx={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.3)",
                zIndex: 999,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}>
                <LinearProgress variant="determinate" value={pg} sx={{ width: '50%' }} />
              </Box>
      
             ) : ( 


      <Box sx={{ width: '100%',display: "flex",flexDirection: "column", marginLeft:0, marginBottom:0, boxShadow: "none",marginTop: "0px",border: "0px solid #e0e0e0" ,boxSizing: "border-box",
        backgroundColor: "background.paper",
      }}>
        <Box sx={{ borderRadius: 0,boxSizing: "border-box",marginBottom:0, boxShadow: "none",marginTop: "0px",
          textAlign: "center",
          verticalAlign: "middle",
          padding:1,
          backgroundColor: "#f5f5f5",
          fontSize: "calc(14px + 0.5vw)",
          fontWeight: "bold",
          color: "#333",
        }}>
          ข้อมูลสมุดบัญชีธนาคาร - ตรวจสอบข้อมูล
        </Box>

        <Box sx={{  marginBottom:"4px", boxShadow: "none",marginTop: "4px",border: "1px solid #e0e0e0" ,boxSizing: "border-box",
                                borderRadius: 0,textAlign: "center",verticalAlign: "middle",fontSize: "calc(14px - 0.01vw)",padding:1,
                                display: "flex",            
                                justifyContent: "center",
                                alignItems: "center",
                                gap: 2, flexWrap: "wrap",
                              }}>

            
            <Autocomplete
              multiple
              options={ac}
              getOptionLabel={(option) =>
                `${option.c11} - ${option.c2} (${option.c12})`
              }
              value={sac}
              onChange={(event, newValue) => {
                sSAc(newValue);
              }}
              renderInput={(params) => (
                <TextField {...params} label="เลือกบัญชีธนาคาร" placeholder="เลือกได้หลายบัญชี" style={{ width: 300}} size="small" id="account" 
                  // sx={{
                  //     fontSize: 11,
                  //     '& .MuiChip-label': {
                  //       fontSize: 10,
                  //     },
                  //   }}
                />
              )}
              PaperComponent={(props) => (
                <Paper
                  {...props}
                  // sx={{
                  //   fontSize: 11,
                  //   '& .MuiAutocomplete-listbox': {
                  //     fontSize: 11,
                  //     padding: 0,
                  //   },
                  //   '& .MuiAutocomplete-option': {
                  //     fontSize: 11,
                  //     paddingTop: 4,
                  //     paddingBottom: 4,
                  //   },
                  // }}
                />
              )}
            />

          <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker label="เลือกวันที่เริ่มต้น"
                          value={d2}
                          onChange={(newValue) => {
                            sD2(newValue);
                            if (d3 && newValue && d3 < newValue) {
                              sD3(null);
                            }
                          }}
                          sx={{ width: 190 }}
                          slotProps={{
                            field: { clearable: true, onClear: () => sD2(null) },
                            textField: { 
                              size: 'small',
                              placeholder: 'Select Date',
                            },
                          }}
                          
                        />

              <DatePicker label="เลือกวันที่สิ้นสุด"
                          value={d3}
                          onChange={(newValue) => sD3(newValue)}
                          disabled={!d2}  
                          minDate={d2}    
                          sx={{ width: 190 }}
                          slotProps={{
                            field: { clearable: true, onClear: () => sD3(null) },
                            textField: { size: 'small',placeholder: 'Select End Date'},
                          }}
                          
                        />

              
          </LocalizationProvider>

          <button
                  onClick={fR}
                  style={{
                    padding: "8px 15px",
                    background: "#0061d4",
                    color: "white",
                    border: "none",
                    cursor: "pointer",
                    fontSize: "calc(8px + 0.5vw)",
                    marginRight: "10px",
                  }}
                >
                  แสดงข้อมูล
              </button>

        </Box>

        {d.length <= 0 && (
                <Box sx={{  marginBottom:"4px", boxShadow: "none",marginTop: "0px",border: "1px solid #e0e0e0" ,boxSizing: "border-box",
                  borderRadius: 0,textAlign: "center",verticalAlign: "middle",fontSize: "calc(14px - 0.01vw)",padding:1,
                }}>
                      "กรุณาคลิกแสดงข้อมูล"
                </Box>
                )}
        
        {d.length > 0 && (
        
          <TableContainer
            component={Paper}
            sx={{
              maxHeight: 400,
              overflow: "auto", 
              minWidth: 800,    
            }}
          >
            <Table size="small" aria-label="a dense table" sx={{ borderCollapse: 'collapse' }}>
              <TableHead sx={{ backgroundColor: '#f5f5f5',whiteSpace: "nowrap", }}>
                <TableRow sx={{ height: 40 }}>
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)'}}>
                    <input
                      type="checkbox"
                      onChange={hCbA}
                      checked={s.length === d.length}
                    />
                  </TableCell>
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>ลบข้อมูล</TableCell>
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)'}}>#</TableCell>
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>ธนาคาร</TableCell>
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>ประเภทบัญชี</TableCell>
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>เลขที่บัญชี</TableCell>
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>วันที่ธนาคาร</TableCell>                  

                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>เงินนำฝากเข้าบัญชี</TableCell>
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>ชื่อลูกหนี้/ผู้โอนเงิน</TableCell>
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>เงินหักบัญชี</TableCell>
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>ชื่อเจ้าหนี้/ผู้รับเงิน</TableCell>                  

                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>ยอดคงเหลือ</TableCell>
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>เลขที่เช็ค</TableCell>
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>หมายเหตุ</TableCell>
                  
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>ผู้บันทึกข้อมูล</TableCell>
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>บันทึกข้อมูลเมื่อ</TableCell> 

                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>สกุลเงิน</TableCell>
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>เงินฝากต่างประเทศ</TableCell>
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>เงินหักต่างประเทศ</TableCell>                 

                </TableRow>
              </TableHead>

              <TableBody>
                {d.map((file, index) => (
                  <TableRow sx={{ height: 40 }}
                    key={index}
                  >
                    <TableCell align="center" component="th" scope="row" sx={{ whiteSpace: "pre-wrap", border: '1px solid rgba(0, 0, 0, 0.3)' }}>
                      <input
                        type="checkbox"
                        checked={s.some((f) => f.i13 === file.i13)}
                        onChange={() => hCbS(file)}
                      />
                    </TableCell>

                    <TableCell align="center" sx={{ whiteSpace: "pre-wrap", border: '1px solid rgba(0, 0, 0, 0.3)' }}>
                      <IconButton onClick={() => hD(file)} color="error">
                          <DeleteIcon />
                      </IconButton>
                    </TableCell>

                    <TableCell align="center" component="th" scope="row" sx={{whiteSpace: "pre-wrap", border: '1px solid rgba(0, 0, 0, 0.3)' }}>
                      {index+1}
                    </TableCell>

                    <TableCell align="left" sx={{whiteSpace: "pre", border: '1px solid rgba(0, 0, 0, 0.3)' }} >{file.t0801c11}</TableCell>
                    <TableCell align="left" sx={{whiteSpace: "pre", border: '1px solid rgba(0, 0, 0, 0.3)' }} >{file.t0801c12}</TableCell>

                    <TableCell align="left" sx={{whiteSpace: "pre", border: '1px solid rgba(0, 0, 0, 0.3)' }} >{file.c1}</TableCell>

                    <TableCell align="center" sx={{ whiteSpace: "pre", border: '1px solid rgba(0, 0, 0, 0.3)' }}>
                      {file.d2 ? new Date(file.d2).toISOString().split("T")[0] : ""}
                    </TableCell>                    

                    <TableCell align="right" sx={{whiteSpace: "pre", border: '1px solid rgba(0, 0, 0, 0.3)' }}>
                      {new Intl.NumberFormat('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(file.d3)}
                    </TableCell>
                    <TableCell align="left" sx={{whiteSpace: "pre-wrap", border: '1px solid rgba(0, 0, 0, 0.3)' }} >
                      {file.t0201c1 ? file.t0201c1 : file.t0601c1}
                      </TableCell>
                    <TableCell align="right" sx={{whiteSpace: "pre", border: '1px solid rgba(0, 0, 0, 0.3)' }}>
                        {new Intl.NumberFormat('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(file.d5)}
                    </TableCell>
                    <TableCell align="left" sx={{whiteSpace: "pre-wrap", border: '1px solid rgba(0, 0, 0, 0.3)' }} >
                      {file.t0301c1 ? file.t0301c1 : file.t0701c1}
                      </TableCell>                                        

                    <TableCell align="right" sx={{whiteSpace: "pre", border: '1px solid rgba(0, 0, 0, 0.3)' }}>
                        {new Intl.NumberFormat('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(file.d7)}
                    </TableCell>
                    <TableCell align="left" sx={{whiteSpace: "pre-wrap", border: '1px solid rgba(0, 0, 0, 0.3)' }}>{file.c8}</TableCell>
                    <TableCell align="left" sx={{whiteSpace: "pre-wrap", border: '1px solid rgba(0, 0, 0, 0.3)'}}>{file.c9}</TableCell>

                    <TableCell align="center" sx={{ whiteSpace: "pre-wrap", border: '1px solid rgba(0, 0, 0, 0.3)' }}>
                      {file.c14}
                    </TableCell>
                    <TableCell align="center" sx={{ whiteSpace: "pre-wrap", border: '1px solid rgba(0, 0, 0, 0.3)' }}>
                      {file.tt15}
                    </TableCell>

                    <TableCell align="left" sx={{whiteSpace: "pre", border: '1px solid rgba(0, 0, 0, 0.3)' }} >{file.c43}</TableCell>
                    <TableCell align="right" sx={{whiteSpace: "pre", border: '1px solid rgba(0, 0, 0, 0.3)' }}>
                      {new Intl.NumberFormat('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(file.d44)}
                    </TableCell>
                    <TableCell align="right" sx={{whiteSpace: "pre", border: '1px solid rgba(0, 0, 0, 0.3)' }}>
                        {new Intl.NumberFormat('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(file.d45)}
                    </TableCell>

                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
        
        {s.length > 0 && (
          <Box sx={{  marginBottom:0, boxShadow: "none",marginTop: "4px" ,boxSizing: "border-box",
            borderRadius: 0,
            padding: "4px 4px",
            textAlign: "center",
            verticalAlign: "middle",
          }}>

            <button
              onClick={hDS}
              style={{
                padding: "8px 15px",
                background: "#e40000",
                color: "white",
                border: "none",
                cursor: "pointer",
                fontSize: "calc(8px + 0.5vw)",
              }}
            >
              ลบข้อมูล
            </button>
          </Box>
        )}

      </Box>

      )}


    </Container>
  );
};

export default DisplayBookbank;